import { sleep } from "./utils";

export async function processInput(className, input, superTerminal) {
  if (input.length > 0) {
    // todo
  } // end checking for zero length of the user's answer

  superTerminal.writePromptCommand();
}
